(() => {
  const realBtn = document.querySelector('product-form button[name="add"], button[name="add"]');
  const form = realBtn?.closest('form') || document.querySelector('product-form form');
  if (!realBtn) return;

  // Encontrar fieldsets de talle (los que tienen (Size) en el legend)
  const sizeFieldsets = [...document.querySelectorAll('fieldset')]
    .filter(fs => fs.querySelector('legend.form__label')?.textContent?.includes('(Size)'))
    .slice(0, 2); // TOP y BOTTOM

  // Si no hay 2, igual funciona con 1
  const getLegendName = (fs) =>
    (fs.querySelector('legend.form__label')?.textContent || 'Talle').replace('(Size)', '').trim();

  const getValues = (fs) =>
    [...fs.querySelectorAll('input[type="radio"]')].map(i => i.value).filter(Boolean);

  const findRadio = (fs, value) =>
    fs.querySelector(`input[type="radio"][value="${CSS.escape(value)}"]`);

 let title = (document.querySelector('.product__title, h1')?.textContent || 'Producto')
  .replace(/\s+/g, ' ')
  .trim();

// Si por algún motivo el H1 trae el texto repetido, cortamos desde la 2da vez que aparece "CONJUNTO"
const upper = title.toUpperCase();
const secondConjunto = upper.indexOf('CONJUNTO', upper.indexOf('CONJUNTO') + 1);
if (secondConjunto !== -1) {
  title = title.slice(0, secondConjunto).trim();
}
const priceText = (document.querySelector('.price-item--sale, .price-item--regular')?.textContent || '').trim();
const imgEl = document.querySelector('.product__media img, media-gallery img');
const imgSrc = imgEl?.currentSrc || imgEl?.src || '';

const bar = document.createElement('div');
bar.className = 'sticky-buy';

bar.innerHTML = `
  <div class="sticky-buy__inner">
    <div class="sticky-buy__left">
      ${imgSrc ? `<img class="sticky-buy__img" src="${imgSrc}" alt="">` : ''}
      <div class="sticky-buy__meta">
        <div class="sticky-buy__title">${title}</div>
        <div class="sticky-buy__price">${priceText}</div>
      </div>
    </div>

    <div class="sticky-buy__sizes"></div>

    <button type="button" class="button button--primary sticky-buy__btn">Agregar al carrito</button>
  </div>
`;
document.body.appendChild(bar);
// --- FORCE layout mobile: padding + fondo siempre correctos ---
bar.style.background = '#fff';
bar.style.opacity = '1';
bar.style.zIndex = '2147483647';

const applyStickySpace = () => {
  const h = bar.getBoundingClientRect().height || 0;
  // le sumo un margen por iPhone + Safari bottom bar
  document.body.style.paddingBottom = (h + 24) + 'px';
};

// cuando se muestra/oculta (tu código ya toggletea is-visible)
applyStickySpace();
window.addEventListener('resize', applyStickySpace);

const sizesWrap = bar.querySelector('.sticky-buy__sizes');
const stickyBtn = bar.querySelector('.sticky-buy__btn');

  // Click sticky = click botón real
  stickyBtn.addEventListener('click', () => realBtn.click());

  // Render de cada grupo (TOP/BOTTOM)
  const groups = sizeFieldsets.map((fs, idx) => {
    const title = getLegendName(fs);
    const values = [...new Set(getValues(fs))];

    const el = document.createElement('div');
    el.className = 'sticky-buy__group';
    el.innerHTML = `
      <div class="sticky-buy__group-title">${title}</div>
      <div class="sticky-buy__pills" data-idx="${idx}">
        ${values.map(v => `<button type="button" class="sticky-pill" data-value="${v}">${v}</button>`).join('')}
      </div>
    `;
    sizesWrap.appendChild(el);

    // Click en pill => click en radio real
    el.querySelector('.sticky-buy__pills').addEventListener('click', (e) => {
      const btn = e.target.closest('.sticky-pill');
      if (!btn) return;
      const value = btn.dataset.value;
      const radio = findRadio(fs, value);
      if (radio && !radio.disabled) radio.click();
    });

    return { fs, el };
  });

  // Sync UI (checked/disabled/texto del botón)
  const sync = () => {
    stickyBtn.disabled = realBtn.disabled;
    stickyBtn.textContent = realBtn.textContent.trim() || 'Agregar al carrito';

    groups.forEach(({ fs, el }) => {
      const pills = [...el.querySelectorAll('.sticky-pill')];
      pills.forEach(p => {
        const v = p.dataset.value;
        const r = findRadio(fs, v);
        if (!r) return;
        p.classList.toggle('is-active', r.checked);
        p.disabled = r.disabled;
      });
    });
  };

  // Solo eventos livianos (NO MutationObserver global)
  document.addEventListener('change', (e) => {
    if (e.target && (e.target.matches('input[type="radio"]') || e.target.closest('fieldset'))) sync();
  }, true);

// Mostrar/ocultar: solo después de pasar la zona del form (evita que aparezca desde el inicio)
let activated = false;

const triggerEl = form || realBtn; // "form" ya lo tenés arriba: const form = realBtn?.closest('form')...
const isInViewport = (el) => {
  const r = el.getBoundingClientRect();
  return r.top < window.innerHeight && r.bottom > 0;
};

const updateSticky = () => {
  // Se activa cuando ya pasaste el trigger (form/botón) hacia arriba
  const triggerRect = triggerEl.getBoundingClientRect();
  activated = triggerRect.top < 0;

  const realVisible = isInViewport(realBtn);
  const show = activated && !realVisible;

  bar.classList.toggle('is-visible', show);
  document.body.classList.toggle('has-sticky-buy', show);
  if (show) sync();
};

window.addEventListener('scroll', updateSticky, { passive: true });
window.addEventListener('resize', updateSticky);
updateSticky();
})();